import EducationCategoryCodebookContainer from '@src/components/codebook/EducationCategoryCodebookContainer';
import withLocalize, { IWithLocalizeOwnProps } from '@src/components/common/localize/withLocalize';
import withRoles, { IWithRolesOwnProps } from '@src/components/common/role/withRoles';
import withTenantPropEnabled, { IWithTenantPropEnabledOwnProps } from '@src/components/tenant/withTenantPropEnabled';
import { Empty } from 'antd';
import React from 'react';

// -- Component
// ----------
interface IAdminEducationCategoryPageOwnProps { }
type IAdminEducationCategoryCodebookPageProps = IWithRolesOwnProps & IWithTenantPropEnabledOwnProps & IWithLocalizeOwnProps;

// -- Component
// ----------

const AdminEducationCategoryCodebookPage = (props: IAdminEducationCategoryCodebookPageProps) => {
  const DisplayComponent = (props.isSuperAdmin() || props.isTenantPropEnabled('codebook_education_category')) ? <EducationCategoryCodebookContainer /> : <Empty description={props.translate('COMMON.LABEL.NOT_ALLOWED_TO_ACCESS')} />;
  return (
    <React.Fragment>
      {DisplayComponent}
    </React.Fragment>
  );
};

export default withTenantPropEnabled<IAdminEducationCategoryPageOwnProps>(withLocalize(withRoles(AdminEducationCategoryCodebookPage as any)));
